// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-course {
  margin: 40px;
  margin-top: 20px;
}
@media screen and (max-width: 800px) {
  .widget-course {
    margin: 20px;
  }
}
.widget-course .back-button {
  padding-left: 0;
  margin-bottom: 20px;
}
.widget-course .ant-layout {
  border-radius: 8px;
  min-height: 200px;
  padding: 20px;
}
.widget-course .ant-layout .hero-image {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
  min-height: 190px;
}
.widget-course .ant-layout .hero-image .ant-image {
  max-height: 300px;
  border-radius: 8px;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/WidgetCourse/styles.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;AACJ;AACI;EAAA;IACI,YAAA;EAEN;AACF;AARA;EASQ,eAAA;EACA,mBAAA;AAER;AAZA;EAcQ,kBAAA;EACA,iBAAA;EACA,aAAA;AACR;AAjBA;EAmBY,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACZ;AAvBA;EAyBgB,iBAAA;EACA,kBAAA;EACA,gBAAA;AAChB","sourcesContent":[".widget-course {\n    margin: 40px;\n    margin-top: 20px;\n\n    @media screen and ( max-width: 800px ) {\n        margin: 20px;\n    }\n\n    .back-button {\n        padding-left: 0;\n        margin-bottom: 20px;\n    }\n\n    .ant-layout {\n        border-radius: 8px;\n        min-height: 200px;\n        padding: 20px;\n\n        .hero-image {\n            display: flex;\n            justify-content: center;\n            margin-bottom: 14px;\n            min-height: 190px;\n            \n            .ant-image { \n                max-height: 300px;\n                border-radius: 8px;\n                overflow: hidden;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
